module.exports = __webpack_public_path__ + "img/leftarrow.975d8604.svg";